import React, { useCallback, useMemo } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { useFormikContext } from 'formik';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL FUNCTIONS
import { formatDate, apiFetch } from 'functions.js';

// GLOBAL HELPERS
import { sidebarActions } from 'actions.js';

// GLOBAL COMPONENTS
import Button from 'core/tools/Button';
import Form from 'core/form/Form';
import Sidebar from 'parts/sidebar/Sidebar';

// STYLES
import styles from './estimatedDeliveryDate.module.scss';

// VARIABLES
const TODAY = new Date();

// MAIN COMPONENT
export default function EstimatedDeliveryDate() {
  const dispatch = useDispatch();

  const { values, setFieldValue } = useFormikContext() || {};
  const { estimated_delivery_date, new_estimated_delivery_date } = useMemo(() => values || {}, [values]);
  const estimatedDeliveryDate = useMemo(() => formatDate(estimated_delivery_date), [estimated_delivery_date]);

  const { recordID } = useParams();

  const handleCloseSidebar = useCallback(async () => {
    dispatch(sidebarActions.close());
  }, [dispatch]);

  const handleSaveDate = useCallback(() => {
    apiFetch({
      method: 'PUT',
      endpoint: ENDPOINTS.sales.estimatedDeliveryDate(recordID),
      params: {
        estimated_delivery_date: new_estimated_delivery_date
      },
      onSuccess: () => {
        setFieldValue('estimated_delivery_date', new_estimated_delivery_date);
        handleCloseSidebar();
      },
      successMessage: 'Esimated delivery date updated.',
      errorMessage: 'Unable to update estimated delivery date.'
    });
  }, [handleCloseSidebar, recordID, setFieldValue, new_estimated_delivery_date]);

  return (
    <>
      <Form.Row>
        <Form.PlainText
          label="Estimated Delivery Date"
          as="span"
          value={
            <>
              <span className="me-3">{estimatedDeliveryDate}</span>
              <Sidebar.Button
                name="estimatedDeliveryDateSidebar"
                label="Change"
                variant="link"
                fullWidth={false}
                className={clsx('p-0 border-0', styles.change)}
                onClick={() => setFieldValue('new_estimated_delivery_date', estimatedDeliveryDate)}
              />
            </>
          }
          formGroup={{
            className: 'mb-3'
          }}
        />
      </Form.Row>
      <Sidebar name="estimatedDeliveryDateSidebar" title="Estimated Delivery Date" className={styles.sidebar}>
        <Form.Row>
          <Form.Date minDate={TODAY} name="new_estimated_delivery_date" fullWidth />
        </Form.Row>
        <Form.Row className="flex-grow-0">
          <Form.Col cols={{ sm: 12 }}>
            <Button.Cancel
              icon={{
                use: 'arrow-left',
                order: 1
              }}
              justify="between"
              onClick={handleCloseSidebar}
            />
          </Form.Col>
          <Form.Col cols={{ sm: 12 }}>
            <Button label="Save" onClick={handleSaveDate} icon="checkmark" />
          </Form.Col>
        </Form.Row>
      </Sidebar>
    </>
  );
}
